import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("@/components/dashboard/Dashboard.vue"),
  },
  {
    path: "/fullscreen",
    name: "FullScreenView",
    component: () => import("@/components/dashboard/FullScreenView.vue"),
  },
  {
    path: "/kiosk",
    redirect: "/fullscreen",
  },

  {
    path: "/applications/:appId",
    name: "ApplicationDetail",
    component: () => import("@/components/application/ApplicationDetail.vue"),
    props: true,
  },
  {
    path: "/logging_groups/:groupId",
    name: "LoggingGroupDetail",
    component: () => import("@/components/application/LoggingGroupMessagesPage.vue"),
    props: true,
  },
  {
    path: "/manage/groups",
    name: "ManageGroups",
    component: () => import("@/components/management/ManageGroups.vue"),
  },
  {
    path: "/manage/clients",
    name: "ManageClients",
    component: () => import("@/components/management/ManageClients.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/components/auth/LoginPage.vue"),
  },
  {
    path: "/set-password",
    name: "SetPassword",
    component: () => import("@/components/auth/SetPassword.vue"),
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () => import("@/components/auth/ChangePassword.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Auth guard
router.beforeEach((to, from, next) => {
  const publicPages = ["/login", "/set-password"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("access_token");

  if (authRequired && !loggedIn) {
    return next("/login");
  }

  next();
});

export default router;
